import {
  ref,
  inject,
} from '@vue/composition-api';
export default ({
  structure,
}, { root }) => {
  const config = inject('config');
  const productName = inject('productName');

  // refs
  const forwardStepsNavigationDisablingFields = ref(null);

  /**
   * Set the question fields that will disable the breadcrumbs forward navigation if changed.
   * Call this inside any core system's Page{productName}Insurance 'created' lifehook (after init)
   * if any field change should disable the forward navigation
   *
   * For now only used on Home
   *
   * @param { questionField: initialValue } navigationStepsDisablingFields object where 'key' is any question field and 'value' is the initial 'form' value for it
   */
  const setBreadcrumbsForwardStepsNavigationDisablingFields = (navigationStepsDisablingFields = null) => {
    forwardStepsNavigationDisablingFields.value = navigationStepsDisablingFields;
  };

  /**
   * Disable breadcrumbs forward steps navigation if any questionField set
   * by 'setForwardStepsNavigationDisablingFields' is changed
   */
  const disableBreadcrumbsForwardStepsNavigation = async (currentStep, form, stepData) => {
    if (currentStep !== 1 || !forwardStepsNavigationDisablingFields.value) return;

    const resettingValuesChanged = Object.keys(forwardStepsNavigationDisablingFields.value).some(field => {
      return stepData?.[field] && forwardStepsNavigationDisablingFields.value?.[field] !== stepData?.[field];
    });
    if (!resettingValuesChanged) return;

    const nextStepId = structure[currentStep]?.stepId;
    // For car, van, bike systems the next step is an array (drivers)
    const isNextStepSavedArray = Array.isArray(form?.[nextStepId]) && form?.[nextStepId].length && form?.[nextStepId][0]?._saved;
    const isNextStepSaved = isNextStepSavedArray || form?.[nextStepId]?._saved;
    if (!isNextStepSaved) return;

    // reset saved status on FE side to prevent from skipping content step submit using breadcrumbs
    isNextStepSavedArray ? form[nextStepId][0]._saved = false : form[nextStepId]._saved = false;

    const processJourneyQuoteData = isNextStepSavedArray ? { ...form[nextStepId][0] } : { ...form[nextStepId] };
    const processJourneyStep = nextStepId === 'drivers' ? 'driver' : nextStepId;

    // reset saved status on BE side
    await root.$api.processJourney({
      productName,
      productPartnerId: config.partner,
      step: processJourneyStep,
      quoteData: processJourneyQuoteData,
    });
  };

  const saveBreadcrumbsForwardStepsNavigationDisablingFieldsValues = async (stepData) => {
    // If we have forward steps navigation disabling fields save their latest values sent to the server
    if (forwardStepsNavigationDisablingFields.value) {
      Object.keys(forwardStepsNavigationDisablingFields.value).map(field => {
        if (stepData?.[field]) forwardStepsNavigationDisablingFields.value[field] = stepData?.[field];
      });
    }
  };

  return {
    // methods
    setBreadcrumbsForwardStepsNavigationDisablingFields,
    disableBreadcrumbsForwardStepsNavigation,
    saveBreadcrumbsForwardStepsNavigationDisablingFieldsValues,
  };
};
